// src/components/ModaleDemande.jsx
// Formulaire « Contacter Thrundrz » : report, annulation ou autre modification
// d'un événement qui a déjà des réservations.

import React, { useState } from "react";
import { X } from "lucide-react";
import { envoyerDemandeEvenement } from "../services/DemandeService";

const TYPES = [
    { id: "report", label: "Reporter (nouvelle date)" },
    { id: "annulation", label: "Annuler l'événement" },
    { id: "modification", label: "Autre modification (lieu, tarifs…)" },
];

const ModaleDemande = ({ evenementId, nbReservations, typeInitial = "report", onEnvoye, onFermer }) => {
    const [type, setType] = useState(typeInitial);
    const [message, setMessage] = useState("");
    const [nouvelleDate, setNouvelleDate] = useState("");
    const [envoi, setEnvoi] = useState(false);
    const [erreur, setErreur] = useState(null);

    const envoyer = async () => {
        if (message.trim().length < 10) {
            setErreur("Expliquez la raison en quelques mots (10 caractères minimum).");
            return;
        }
        if (type === "report" && !nouvelleDate) {
            setErreur("Indiquez la nouvelle date souhaitée.");
            return;
        }
        setEnvoi(true);
        setErreur(null);
        try {
            const res = await envoyerDemandeEvenement(evenementId, {
                type,
                message: message.trim(),
                nouvelle_date: type === "report" ? nouvelleDate : null,
            });
            onEnvoye?.(res.message);
        } catch (e) {
            setErreur(e.message);
        } finally {
            setEnvoi(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl w-full max-w-md p-5 font-Poppins">
                <div className="flex items-start justify-between mb-3">
                    <div>
                        <h2 className="text-base font-extrabold text-gray-900">Contacter Thrundrz</h2>
                        <p className="text-xs text-gray-500 mt-1">
                            {nbReservations} réservation(s) en cours : ce changement doit être validé par notre équipe
                            pour protéger les acheteurs.
                        </p>
                    </div>
                    <button onClick={onFermer} className="text-gray-400 hover:text-gray-700"><X size={18} /></button>
                </div>

                <div className="flex flex-col gap-2 mb-3">
                    {TYPES.map((t) => (
                        <label key={t.id}
                            className={`flex items-center gap-2 px-3 py-2 rounded-xl border text-sm cursor-pointer ${type === t.id ? "border-violet-500 bg-violet-50" : "border-gray-200"}`}>
                            <input type="radio" checked={type === t.id} onChange={() => setType(t.id)} className="accent-violet-600" />
                            {t.label}
                        </label>
                    ))}
                </div>

                {type === "report" && (
                    <input type="datetime-local" value={nouvelleDate} onChange={(e) => setNouvelleDate(e.target.value)}
                        className="w-full border border-gray-200 rounded-xl px-3 py-2 text-sm mb-3" />
                )}

                <textarea value={message} onChange={(e) => setMessage(e.target.value)} maxLength={1000} rows={4}
                    placeholder="Pourquoi ? (salle indisponible, météo, artiste absent…)"
                    className="w-full border border-gray-200 rounded-xl px-3 py-2 text-sm mb-2" />

                {type === "annulation" && (
                    <p className="text-[11px] text-gray-500 mb-2">
                        Si l'annulation est validée, chaque acheteur est prévenu par e-mail et remboursé du montant payé,
                        hors frais de paiement. Vous ne percevez aucune recette pour ces billets.
                    </p>
                )}
                {type === "report" && (
                    <p className="text-[11px] text-gray-500 mb-2">
                        Si le report est validé, les acheteurs sont prévenus et peuvent demander un remboursement
                        s'ils ne peuvent pas venir à la nouvelle date.
                    </p>
                )}

                {erreur && <p className="text-xs text-red-600 mb-2">{erreur}</p>}

                <div className="flex gap-2 mt-2">
                    <button onClick={onFermer} className="flex-1 py-2.5 rounded-xl bg-gray-100 text-gray-700 text-sm font-semibold">
                        Fermer
                    </button>
                    <button onClick={envoyer} disabled={envoi}
                        className="flex-1 py-2.5 rounded-xl text-white text-sm font-semibold disabled:opacity-50"
                        style={{ backgroundColor: "#481699" }}>
                        {envoi ? "Envoi…" : "Envoyer la demande"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModaleDemande;